// mycards strings (ar).
// Machine-drafted — review with a native speaker before launch.
const mycards = {
	mycards: {
		// Status tabs
		tabAll: 'الكل',
		tabDraft: 'مسودة',
		tabSent: 'المُرسلة',
		tabScheduled: 'المجدولة',
		tabWorkflow: 'سير العمل',

		// View toggle
		gridView: 'عرض الشبكة',
		calendarView: 'عرض التقويم',

		// Search
		searchPlaceholder: 'أدخل عنوان البطاقة',

		// Date range filter
		last7Days: 'آخر 7 أيام',
		last15Days: 'آخر 15 يومًا',
		last30Days: 'آخر 30 يومًا',
		last2Months: 'آخر شهرين',
		last6Months: 'آخر 6 أشهر',
		lastYear: 'العام الماضي',
		allCardsRange: 'كل البطاقات',

		viewMore: 'عرض المزيد',

		// Empty state
		emptyState: 'ليس لديك أي بطاقات بعد. انقر على الزر أدناه للبدء.',
		createNewCard: 'إنشاء بطاقة جديدة',

		// Folder bar
		foldersLabel: 'المجلدات',
		allCards: 'كل البطاقات',
		newFolder: 'مجلد جديد',
		addFolder: 'إضافة',
		folderNamePlaceholder: 'اسم المجلد',
		addRemoveCards: 'إضافة / إزالة البطاقات',
		renameFolderText: 'إعادة تسمية المجلد "%{name}"',
		deleteFolderTitle: 'حذف "%{name}"؟',
		deleteFolderText: 'سيتم إزالة المجلد. تبقى البطاقات الموجودة بداخله ويتم إلغاء تصنيفها فقط.',

		// Assign cards modal
		cardsInFolder: 'البطاقات في "%{name}"',
		selectedCount: '%{count} محددة',
		searchCards: 'البحث عن البطاقات…',
		noCardsFound: 'لم يتم العثور على بطاقات.',
		untitledCard: 'بطاقة بدون عنوان',
		btnSave: 'حفظ',
		btnSaving: 'جارٍ الحفظ…',

		// Shared buttons
		btnCancel: 'إلغاء',
		btnRename: 'إعادة تسمية',
		btnDelete: 'حذف',
		btnNo: 'لا',
		btnYes: 'نعم',
		btnEditAnyway: 'التعديل على أي حال',

		// Folder handler errors
		couldNotCreateFolder: 'تعذّر إنشاء المجلد',
		couldNotRenameFolder: 'تعذّر إعادة تسمية المجلد',
		couldNotDeleteFolder: 'تعذّر حذف المجلد',

		// Card handler dialogs
		cardAlreadyDeliveredTitle: 'تم تسليم البطاقة بالفعل',
		cardAlreadyDeliveredText: 'يمكنك استنساخ هذه البطاقة لجدولة بطاقة جديدة',
		workflowWarningTitle: 'تُستخدم هذه البطاقة في سير عمل',
		workflowWarningText: 'قد يؤدي تعديل علامات الدمج أو المحتوى إلى تعطيل سير عملك الحالي. هل أنت متأكد أنك تريد المتابعة؟',
		openCardErrorTitle: 'حدثت مشكلة أثناء فتح هذه البطاقة. يرجى الاتصال بالدعم',
		deleteCardTitle: 'هل أنت متأكد؟',
		deleteCardText: 'هل تريد حذف هذه البطاقة؟',
		errorTitle: 'خطأ',
	} as Record<string, string>,
};
export default mycards;
